module.exports = __webpack_public_path__ + "static/media/reloj.602a5a01.svg";